<div [className]="className" [style]="styleName">
     
     <div *ngIf="hintText" [className]="hintClass"  [innerHTML]="hintText|translate:hintParam"
                               [style]="hintlStyle" [translateParams]="hintParam"></div>

     <div class="ontario-checkboxes__item">
           
         <input id="{{name}}" contenteditable
                type="checkbox" 
                [className]="inputClass" 
                [style]="inputStyle"
                [attr.disabled]="disable?true:null"
                [checked]="input==trueValue"
                (change)="onChange()"
                attr.aria-describedby="error_{{name}}">

         <label for="{{name}}" 
               [className]="labelClass" 
               [style]="labelStyle"  style="width:auto"
               [translateParams]="labelParam" translate>
               <span [innerHTML]="label|translate:labelParam"></span>
               <ng-content></ng-content>
         </label>
      </div>

     
      <div [hidden]="!error" 
           [className]="errorClass" 
            style="margin-left:0.18em"
           [style]="errorStyle" id="error_{{name}}">
             <b>{{!error? '':'error.prefix'| translate}}</b>
             <span [innerHTML]="error|translate:errorParam" ></span>
      </div>
</div>
